import { HackleClient } from "./hackle";
import { CommonEventProps } from "../types";

declare global {
  interface Window {
    dataLayer: any[];
    dablena: any;
    fbq: any;
    wcs_add: any;
    _nasa: any;
    wcs: any;
    wcs_do: any;
    hackleClient: any;
    hackleUser: any;
    kakaoPixel: any;
  }
}

export const customEvent = (event: CommonEventProps) => {
  if (process.env.NODE_ENV === "development") {
    console.log("event", event);
  }

  if (event) {
    NewGTMCustomEvent(event);
    TriggerHackleCustomEvent(event);
  }
};

const parseEventPropsToClickEventName = (event: CommonEventProps) => {
  if (event.action) {
    return event.action;
  } else {
    const clickEventName = `click-${event.domain}-${event.path}-${event.trigger_and_target}`;
    return clickEventName;
  }
};

export const NewGTMCustomEvent = (event: CommonEventProps) => {
  const eventName = parseEventPropsToClickEventName(event);
  const gtmEventObject = { event: eventName, ...event.properties };

  if (window.dataLayer) {
    window.dataLayer.push({ ...gtmEventObject });
  }
};

export const TriggerHackleCustomEvent = (event: CommonEventProps) => {
  const eventName = parseEventPropsToClickEventName(event);
  const hackleEventObject = {
    key: eventName,
    ...(event.properties && { properties: event.properties }),
  };

  HackleClient.track(hackleEventObject, HackleClient.getUser());
};
